import React, { useEffect } from 'react';
import { locales } from '../../../../translations/locales';
import Loading from '../../../Loading';
import events from '../../../../events';

const Players = (props) => {
    const { theme, locale, data, setActivePage, ModuleRP } = props;
    useEffect(() => {
        if (!data.players || !data.waitingPlayers) {
            ModuleRP.socket.emit(events.CONFIGURE, ModuleRP.gameId);
        }
    }, [data]);

    return (
        data.players ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                {
                    data.waitingPlayers.length > 0 ?
                        (
                            <div className="card container p-0 gameInformations mt-5">
                                <h5 className="card-header bg-primary">
                                    {
                                        data.waitingPlayers.length > 1 ?
                                            locales[locale].config.waitingPlayersTitle :
                                            locales[locale].config.waitingPlayerTitle
                                    }
                                </h5>
                                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                    <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                        <thead>
                                            <tr>
                                                <th>{locales[locale].gamesTable.gameNames}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.waitingPlayers.map((player) =>
                                                (<tr key={player.id}>
                                                    <td>{player.name}</td>
                                                    <td className='float-right'>
                                                        <button
                                                            className='btn btn-sm btn-danger m-1'
                                                            id={'btn-refusePlayer-' + player.id}
                                                            onClick={() => ModuleRP.config.refusePlayer(player.id)}
                                                        >
                                                            {locales[locale].config.refuse}
                                                        </button>
                                                        <button
                                                            className='btn btn-sm btn-success m-1'
                                                            id={'btn-acceptPlayer-' + player.id}
                                                            onClick={() => ModuleRP.config.acceptPlayer(player.id)}
                                                        >
                                                            {locales[locale].config.accept}
                                                        </button>
                                                    </td>
                                                </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            ''
                        )
                }
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">
                        {locales[locale].config.players}
                    </h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                            <thead>
                                <tr>
                                    <th>{locales[locale].gamesTable.gameNames}</th>
                                    <th>{locales[locale].config.ranks}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.players.map((player) =>
                                    (<tr key={player.id}>
                                        <td>{player.name}</td>
                                        <td>
                                            {
                                                player.ranks.map((rank) => (
                                                    <span
                                                        key={`playerRank_${player.id}_${rank}`}
                                                        className='badge badge-primary p-2 m-1'
                                                    >
                                                        {data.ranks.find((r) => r.id === rank).name}
                                                    </span>
                                                ))
                                            }
                                        </td>
                                        <td>
                                            <button
                                                className='btn btn-sm btn-primary float-right'
                                                id={'btn-managePlayer-' + player.id}
                                                onClick={() => {
                                                    ModuleRP.config.managePlayer(player.id);
                                                    setActivePage('ManagePlayer');
                                                }}
                                            >
                                                {locales[locale].config.manage}
                                            </button>
                                        </td>
                                    </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*
                <div className="card container p-0 gameInformations mt-5">
                    <button
                        className='btn btn-sm btn-success float-right'
                        disabled={true}
                    >
                        ADD BOT - OPTION
                    </button>
                </div>
                */}
            </div> :
            <Loading theme={theme} />
    );
};

export default Players;
